import React, { useMemo } from 'react';
import ReactECharts from 'echarts-for-react';
import { EChartsOption } from 'echarts';
import ChartWrapper from '../../ChartWrapper';
import { LineChartProps } from './types';

const DEFAULT_STYLE = {
  height: 282,
};

const Line = ({ data, title, format }: LineChartProps) => {
  const option: EChartsOption = useMemo(() => {
    return {
      xAxis: {
        type: 'category',
        data: data.dates,
        axisTick: {
          alignWithLabel: true,
        },
      },
      yAxis: {
        type: 'value',
        axisLabel: {
          formatter: format ? format : undefined,
          hideOverlap: false,
          interval: 0,
          overflow: 'truncate',
          width: 50,
          ellipsis: '...',
          verticalAlign: 'top',
        },
        triggerEvent: true,
      },
      tooltip: {
        trigger: 'axis',
        formatter: (params: any) => {
          return `${params[0].name} <br/> <strong>${
            format ? format(params[0].value) : params[0].value
          }</strong>`;
        },
      },
      grid: {
        right: '2%',
        bottom: '10%',
        top: '2%',
        left: '11%',
      },
      series: [
        {
          data: data.series,
          type: 'line',
        },
      ],
    };
  }, [data]);
  return (
    <ChartWrapper>
      <ReactECharts option={option} style={DEFAULT_STYLE} />
    </ChartWrapper>
  );
};

export default React.memo(Line);
